import {
    ActionIcon,
    Alert,
    Box,
    Button,
    Checkbox,
    CloseButton,
    Container,
    Flex,
    Group,
    Image,
    LoadingOverlay,
    Overlay,
    Paper,
    Radio,
    Text,
    Textarea,
    TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import {
    IconAlertTriangle,
    IconArrowRight,
    IconLogin,
    IconQuestionMark,
    IconSend,
} from "@tabler/icons";
import { signIn, useSession } from "next-auth/react";
import { useEffect } from "react";
import { useState } from "react";
import CommentUI from "./CommentUI";

import bgpattern from "../assets/bgpattern.svg";
import { useMediaQuery } from "@mantine/hooks";
import { useMemo } from "react";
import LoginOverlay from "./LoginOverlay";
import Link from "next/link";

const AskDoubts = () => {
    const form = useForm({
        initialValues: {
            doubtQuestionText: "",
        },
        validate: {
            doubtQuestionText: (values) =>
                values.length > 10 ? null : "Question text is too short",
        },
    });

    const defaultPrompt =
        "solve this doubt of a mining engineering student, with explanation on solution: \n";

    const { data: session, status } = useSession();
    const usertype = !!session && !!session.info ? session.info.usertype : null;
    const [doubts, setDoubts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [alertShow, setAlertShow] = useState(["usage", "signinalert"]);
    const [model, setModel] = useState("turbo");
    const [promptPrefix, setPromptPrefix] = useState(defaultPrompt);
    const [show_admin_panel, set_show_admin_panel] = useState(false);
    const smallScreen = useMediaQuery("(max-width: 48em)");

    const [no_prompts, set_no_prompts] = useState(null);

    useEffect(() => {
        // load all the previous doubts and solutions
        if (!!session && !!session.info && doubts.length == 0) {
            setAlertShow((prev) => prev.filter((x) => x != "signinalert"));
            const user_id = session.info.id;
            fetch("/api/solve/doubt/" + user_id)
                .then((res) => res.json())
                .then((resp) => {
                    resp.sort((a, b) => b.created_at - a.created_at);
                    setDoubts(resp);
                    let num_p = 1;
                    if (usertype != "free") num_p = 10;
                    if (resp.length > num_p) {
                        console.log({ r: resp[num_p - 1], len: resp.length });
                        const ts = resp[num_p].created_at;
                        const next_date = new Date(ts);
                        next_date.setDate(next_date.getDate() + 7);
                        console.log(
                            "setting no prompts",
                            next_date.getTime(),
                            Date.now()
                        );
                        if (next_date.getTime() > Date.now()) {
                            set_no_prompts(
                                "You have used all of your free requests, please upgrade to premium plan to get unlimited usage of this service"
                            );
                            console.log(
                                "set no prompts",
                                next_date.getTime(),
                                Date.now()
                            );
                        }
                    }
                    console.log({ initialresp: resp });
                });
        }

        if (!!session && !!session.info && session.info.usertype == "admin") {
            set_show_admin_panel(true);
        }

        // if (usertype != "free") set_available_prompts(500);
    }, [session]);

    const handleOnSubmit = (values) => {
        setLoading(true);
        // post the question text with the userid
        const user_id = session.info.id;
        // const values = form.values;
        const url = process.env.NEXT_PUBLIC_PROMPT_LAMDA;
        const { doubtQuestionText } = values;
        const prompt = `${promptPrefix}${doubtQuestionText}`;

        // start a prompt
        fetch(url, {
            method: "POST",
            body: JSON.stringify({
                data: { prompt, model },
            }),
            // headers: {
            //     "Content-Type": "application/json",
            //     "Access-Control-Allow-Origin": "*",
            //     "Referrer-Policy": "no-referrer",
            // },
        })
            .then((res) => res.json())
            .then((resp) => {
                console.log({ resp });
                return resp;
            })
            .then((resp) => {
                const {
                    text: response,
                    extra: { model, prompt },
                } = resp;
                fetch("/api/solve/doubt/" + user_id, {
                    method: "POST",
                    body: JSON.stringify({
                        ...values,
                        response,
                        model,
                        prompt,
                    }),
                    headers: { "Content-Type": "application/json" },
                })
                    .then((res) => res.json())
                    .then((resp) => {
                        // always insert at top
                        // console.log({ finalresp: resp });
                        const { solution } = resp;
                        setDoubts((prev) => [solution, ...prev]);
                    });
            })
            .finally(() => {
                setLoading(false);
            });

        console.log({ values });
    };

    const doubtitems = useMemo(() => {
        return doubts.map((doubt, idx) => {
            const { actual_text, comment, created_at, user, id } = doubt;
            return (
                <CommentUI
                    key={idx}
                    {...{
                        heading: actual_text,
                        comment,
                        created_at,
                        idx,
                        user,
                        commentid: id,
                    }}
                />
            );
        });
    }, [doubts]);

    console.log({ doubts });
    return (
        <Box>
            <Container>
                <Text component="h1" fz={25} ta={"center"} fw={"bold"}>
                    AI Ace: Doubts Defeated 🎉
                </Text>
                {show_admin_panel && (
                    <Paper withBorder p={5} sx={{ position: "relative" }}>
                        <Box
                            justify={"end"}
                            sx={{ position: "absolute", right: 0 }}
                        >
                            <CloseButton
                                title="Close admin section"
                                size="sm"
                                iconSize={20}
                                onClick={() => {
                                    set_show_admin_panel(false);
                                }}
                            />
                        </Box>
                        <Box>
                            <Box>
                                <Radio.Group
                                    name="which model to select"
                                    label="Select your AI model"
                                    description=""
                                    withAsterisk
                                    value={model}
                                    onChange={(value) => {
                                        setModel(value);
                                    }}
                                >
                                    <Group mt="xs">
                                        <Radio value="gpt4" label="gpt4" />
                                        <Radio
                                            value="turbo"
                                            label="gpt3.5 turbo"
                                        />
                                    </Group>
                                </Radio.Group>
                            </Box>
                            <Box>
                                <Checkbox
                                    checked={!!!promptPrefix}
                                    onChange={(event) => {
                                        if (event.currentTarget.checked)
                                            setPromptPrefix("");
                                        else {
                                            setPromptPrefix(defaultPrompt);
                                        }
                                    }}
                                    label="disable the prefix prompt"
                                />
                            </Box>
                        </Box>
                    </Paper>
                )}
                {alertShow.includes("signinalert") && (
                    <Alert
                        color={"orange"}
                        icon={<IconAlertTriangle />}
                        title={"You're not Logged in"}
                        // withCloseButton
                        // closeButtonLabel="Close alert"
                        // onClose={() => {
                        //     setAlertShow((prev) =>
                        //         prev.filter((x) => x != "signinalert")
                        //     );
                        // }}
                    >
                        You must be signed in, inorder to send doubt solving
                        request.
                        <Button
                            variant="subtle"
                            color={"teal"}
                            onClick={signIn}
                            rightIcon={<IconArrowRight />}
                        >
                            Login Now
                        </Button>
                    </Alert>
                )}

                <form onSubmit={form.onSubmit(handleOnSubmit)}>
                    <Flex gap={10} wrap="wrap" sx={{ position: "relative" }}>
                        <Box sx={{ flexGrow: 1 }}>
                            <Textarea
                                // h={200}
                                withAsterisk
                                size="md"
                                autosize
                                minRows={2}
                                maxRows={4}
                                radius="md"
                                label="What is your doubt?"
                                description="Ask any doubt related to mining engineering"
                                placeholder="for eg. what are drilling methods in mining ?"
                                sx={{ grow: 1 }}
                                {...form.getInputProps("doubtQuestionText")}
                            />
                        </Box>
                        <Flex
                            justify={"end"}
                            direction={"column"}
                            sx={{ alignSelf: "end" }}
                        >
                            {!smallScreen && !!session && (
                                <Button
                                    color={"teal"}
                                    size={"xs"}
                                    fz={"md"}
                                    sx={{ flexGrow: 1 }}
                                    loading={loading}
                                    rightIcon={<IconSend size={18} />}
                                    loaderPosition={"right"}
                                    type={"submit"}
                                >
                                    Solve
                                </Button>
                            )}
                            {smallScreen && !!session && (
                                <ActionIcon
                                    variant="filled"
                                    radius={"sm"}
                                    color={"teal"}
                                    type={"submit"}
                                    loading={loading}
                                    disabled={!!!session}
                                >
                                    <IconSend size={20} />
                                </ActionIcon>
                            )}
                        </Flex>
                        {!!!session && <LoginOverlay />}
                        {!!no_prompts && (
                            <Overlay w={"100%"} h={"100%"}>
                                <Flex
                                    h={"100%"}
                                    justify={"center"}
                                    align={"center"}
                                >
                                    <Link href={"/premium"}>
                                        <Button color="red" radius="xl">
                                            Purchase premium to use more
                                        </Button>
                                    </Link>
                                </Flex>
                            </Overlay>
                        )}
                    </Flex>
                    <Flex justify={"end"}>
                        <Text c="dimmed" italic>
                            It takes less than 2 minutes
                        </Text>
                    </Flex>
                </form>
                <Flex direction={"column"} gap={15} my={30}>
                    {...doubtitems}
                    {doubts.length == 0 && (
                        <Text
                            py={30}
                            c="dimmed"
                            ta={"center"}
                            fw={"bold"}
                            fz={"lg"}
                            sx={(theme) => ({
                                border:
                                    theme.colorScheme == "dark"
                                        ? `5px dashed ${theme.colors.dark[6]}`
                                        : `5px dashed ${theme.colors.gray[2]}`,
                                borderRadius: theme.radius.md,
                            })}
                        >
                            The doubts you ask will be shown here
                        </Text>
                    )}
                </Flex>
            </Container>
        </Box>
    );
};

export default AskDoubts;
